import { PackPopupType } from '@nf/types/promotion';

export const cwcRiskFreeBetKeys = {
	all: ['cwc-risk-free-bet'] as const,
	amount: () => [...cwcRiskFreeBetKeys.all, 'amount'] as const,
	popupStatus: (popupTypes: Array<PackPopupType>) =>
		[...cwcRiskFreeBetKeys.all, 'popup-status', ...popupTypes] as const,
};